import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

export const Loader = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "grid",
        placeItems: "center",
      }}
    >
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <CircularProgress
          sx={{
            height: "30px !important",
            width: "30px !important",
            display: "block",
            mb: "8px",
          }}
        />
        Please wait. Data fetching...
      </Box>
    </Box>
  );
};
